import type { FC } from "react";
import { Polygon, type PolygonProps } from "react-leaflet";
import { addParcelPolygonExportClass } from "../utils/parcelPolygonExport";

/**
 * 地図出力（PNG/PDF/プレビュー）に含める地番ポリゴン。
 *
 * 出力対象の識別はマーカークラス（MAP_EXPORT_PARCEL_POLYGON_CLASS）で行うが、
 * react-leaflet の pathOptions.className は地図追加後の setStyle 適用となり
 * DOM に反映されないため、add イベントで要素へ直接付与する。
 */
export const ParcelPolygon: FC<PolygonProps> = ({
  eventHandlers,
  ...props
}) => (
  <Polygon
    {...props}
    eventHandlers={{
      ...eventHandlers,
      add: (event) => {
        addParcelPolygonExportClass(event);
        eventHandlers?.add?.(event);
      },
    }}
  />
);
